import React, { Fragment, useEffect, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  loadFromLocalStorage,
  saveToLocalStorage,
} from "../../../utils/LocalStorageUtils";
import {
  apiCall,
  failedMessage,
  setDefaultHeader,
  successMessage,
} from "../../../utils/httpClient";
import { Button, Card, CloseButton, Container, Spinner } from "react-bootstrap";
import { CardBody, Modal, ModalHeader } from "reactstrap";
import { isEmpty } from "../../../utils/utils";
import LoginCover from '../logincover.png';
import "../auth.css";
import { FaApple, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

function CreatePassword() {
  const [email, setEmail] = useState("");
  const [emailForget, setEmailForget] = useState("");
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  useEffect(() => {
    const authData = loadFromLocalStorage("EMAIL_ADDRESS");
    if (!isEmpty(authData)) {
      setEmail(authData)
    }
  }, [])
  if (authData?.token) {
    return <Navigate to="/" />;
  }

  const validationPassword = () => {
    let isError = true;
    let errorMessage = {};

    if (password === undefined || password === "") {
      isError = false;
      errorMessage["password"] = "Please Enter Password";
    }
    if (cPassword === undefined || cPassword === "") {
      isError = false;
      errorMessage["cPassword"] = "Please Enter Retype Password";
    }
    if (cPassword !== password) {
      isError = false;
      errorMessage["cPassword"] = "Retype Password Not Match";
    }
    setErrorMessage(errorMessage);
    return isError;
  };

  const handleUpdatePassword = async () => {
    if (validationPassword()) {
      setLoading(true);
      const params = {
        email: email,
        password: password
      };
      const { data } = await apiCall("post", apiEndPoint.UPDATEPASSWORD, params );
      if (data.status !== 200) {
        failedMessage(data.message);
      } else {
        navigate("/login");
      }
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <Container>
        <section className="log-in-section">
          <div className="login-bg">
            <div className="">
              <img
                src="/assets/images/fulllogo.png"
                alt="" width={200}
              />
            </div>
            <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-4 my-col-2">
                <div className="lt-text">
                  <h3 style={{ marginBottom: 0 }}>Forgot your Password?</h3>
                  <p>Don’t worry. We got you covered.</p>
                </div> <br />
                <form>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>New Password</label>
                          <input
                            htmlFor="newpassword"
                            value={password}
                            type="password"
                            size="large"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={"New password"}
                            className={`${errorMessage.password ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.password && (
                            <span className="er-msg-show">
                              {errorMessage.password}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Retype Password</label>
                          <input
                            type="password"
                            htmlFor="password"
                            value={cPassword}
                            size="large"
                            onChange={(e) => setCPassword(e.target.value)}
                            placeholder={"Retype Password"}
                            className={`${errorMessage.cPassword ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.cPassword && (
                            <span className="er-msg-show">
                              {errorMessage.cPassword}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="sav-btn mt-adj">
                      <button
                        type="button"
                        onClick={() => handleUpdatePassword()}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          "Confirm"
                        )}
                      </button>
                    </div>
                  </div>
                </form>

                <p className="pos-adj mt-4 text-center">
                  <a style={{ textDecoration: 'underline' }}
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Back to Login Page
                  </a>
                </p>
              </div>
              <div className="col-lg-8 my-col-1">
                <div className="text-center">
                  <img src={LoginCover} alt="login-vector" className="login-vector" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </Fragment>
  );
}

export default CreatePassword;